<template>
  <div class="animatedContentSwap overflow-hidden" :style="{ height }">
    <Transition mode="out-in" name="fade4" @after-enter="releaseHeight" @before-leave="fixToCurrentHeight" @enter="fixToCurrentHeight">
      <slot />
    </Transition>
  </div>
</template>

<script lang="ts" setup>
const height = ref<string>();

// 高さを auto のままにすると、入れ替わりの瞬間に一段詰まってフェードが目に入らない
const fixToCurrentHeight = (el: Element) => {
  height.value = `${(el as HTMLElement).offsetHeight}px`;
};
const releaseHeight = () => {
  height.value = undefined;
};
</script>

<style lang="scss" scoped>
.animatedContentSwap {
  transition: height 0.3s ease-in-out;
}
</style>
